const CONTROL_TYPES = {
  DATE: 'date',
  NUMBER: 'numeric',
  TEXT: 'text',
};

export default CONTROL_TYPES;
